<template>
    <div class="animated fadeIn">
        <b-row v-if="isUserSuperAdmin">
            <b-col cols="12">
                <b-button v-on:click="backToChatGroups" variant="secondary">
                    <i class="fa fa-arrow-circle-left"></i>&nbsp;Back
                </b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <h1>Print Plate Support</h1>
            </b-col>
        </b-row>
        <b-card class="message-input-container">
                <div slot="header">
                    <strong>Message</strong>
                </div>
                <div class="form-container">
                    <b-row>
                        <b-col>
                            <b-form-textarea id="messageContent" v-model="currentMessage" @keyup.enter.native="sendMessage" :textarea="true" :rows="3" placeholder="Message..."></b-form-textarea>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-button class="mt-2" variant="success" @click="sendMessage">
                                <i class="fa fa-send"></i>&nbsp;Send
                            </b-button>
                        </b-col>
                    </b-row>
                </div>
            </b-card>
        <b-card>
            <div slot="header">
                <strong>Current Chat</strong>
            </div>
            <div class="form-container chat-messages-scroll-window">
                <b-row class="new-message-row" v-for="message in messages" v-bind:key="message.id">
                    <b-col>
                        <div v-if="isMyMessage(message)" class="message my-message">
                            <b-row>
                                <b-col class="message-avatar-col">
                                    <div class="c-avatar">
                                        <img src="img/avatars/person.png" alt="admin@bootstrapmaster.com" class="message-avatar">
                                    </div>
                                </b-col>
                                <b-col>
                                    <div class="inner-message">
                                        <div>
                                            <small class="text-muted">{{message.fullname}} - {{message.time}}</small>
                                        </div>
                                        <div class="font-weight-bold">
                                            {{message.text}}
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>                            
                        </div>
                        <div v-if="!isMyMessage(message)" class="message their-message">
                            <b-row>
                                <b-col class="message-avatar-col">
                                    <div class="c-avatar">
                                        <img src="img/avatars/person.png" alt="admin@bootstrapmaster.com" class="message-avatar">
                                    </div>
                                </b-col>
                                <b-col>
                                    <div class="inner-message">
                                        <div>
                                            <small class="text-muted">{{message.fullname}} - {{message.time}}</small>
                                        </div>
                                        <div class="font-weight-bold">
                                            {{message.text}}
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>                           
                        </div>
                    </b-col>                            
                </b-row>                        
            </div>
        </b-card>
    </div>
</template>

<script>

import firebaseApp from '../../firebase';

const getHTTPHeaders = () => {
    let userObj = JSON.parse(localStorage.getItem('user'));
    return {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': 'Bearer ' + userObj.token,
      }
    };
}


export default {
  name: 'chatroom',
  components: {
  },
  data () {
    return {
        user: {},
        userAuthLevel: '',
        messages: [],
        currentMessage: '',
        currentChatGroupId: '',
        groupIsActive: false
    }
  },
  watch: {
  },
  mounted() {
      let self = this;
      let chatGroupId = this.$route.params.chatgroupid;
      this.$data.currentChatGroupId = chatGroupId;

      const itemsRef = firebaseApp.database().ref('chatGroups/' + chatGroupId + '/messages');

      itemsRef.on('value', (snapshot) => {
          let data = snapshot.val();
          let messages = [];
          if (data !== null) {
            Object.keys(data).forEach((key) => {
                
                const formatTime = ((milli) => {
                    const messageTime = new Date(milli);
                    const hours = messageTime.getHours().toString().length < 2 ? "0" + messageTime.getHours().toString() : messageTime.getHours().toString();
                    const minutes = messageTime.getMinutes().toString().length < 2 ? messageTime.getMinutes().toString() + "0" : messageTime.getMinutes().toString();
                    return hours + ":" + minutes;
                });
                
                messages.unshift({
                    id: key,
                    username: data[key].username,
                    fullname: data[key].fullname,
                    auth: data[key].auth,
                    text: data[key].text,
                    time: formatTime(data[key].timestamp)
                });
                this.$data.groupIsActive = true;
            });

            self.$data.messages = messages;
          }
          else {
            self.$data.messages = [];
            if (this.$data.groupIsActive) {
                // means the group has been deleted so go back to chat page
                this.backToChatGroups();
            }
          }
      })
  },
  created () {
      this.$data.user = JSON.parse(localStorage.getItem('user'));
  },
  computed: {
    isUserSuperAdmin() {
        if (this.$data.user.auth == 'Super Admin') {
            return true;
        }
        else {
            return false;
        }
    }
  },
  methods : {
    getCurrentUser () {
        return new Promise((resolve, reject) => {
            let user = JSON.parse(localStorage.getItem('user'));
            if (user != null) {
                resolve(user);
            }
            else {
                reject();
            }
        });
    },
    isMyMessage(message) {
        console.log(message);
        return message.username == this.$data.user.username;
    },
    sendMessage() {

        if(this.$data.currentMessage.length > 0) {
            const message = {
                username: this.$data.user.username,
                fullname: this.$data.user.firstName + " " + this.$data.user.lastName,
                auth: this.$data.user.auth,
                text: this.$data.currentMessage,
                timestamp: Date.now()
            }
            // Push message to firebase
            firebaseApp.database().ref('chatGroups/' + this.$data.currentChatGroupId + '/messages').push(message);

            this.$data.currentMessage = '';
            //window.scrollTo(0,document.body.scrollHeight);
        }
    },
    backToChatGroups() {
        this.$router.push({ path: '/chat' });
    }
  }
}
</script>

<style scoped>

    .message-avatar {
        max-width: 40px;
        padding: 2px;
        margin-left: 15px;
        border: 1px solid #fff;
        border-radius: 15px;
    }

    .message-avatar-col {
        -ms-flex: 0 0 50px;
        flex: 0 0 50px;
    }

    .c-avatar {
        display: inline-block;
    }

    div.message {
        background-color: rgb(255, 233, 153);
        border-radius: 15px;
        margin-bottom: 10px;
        padding-top: 10px;
        padding-bottom: 10px;
        width: 80%;
    }
    div.message.their-message {
        background-color: gainsboro;
        float: right;
    }

    div.inner-message {
        display: inline-block;
        padding-right: 20px;
        margin-left: -17px;
    }

</style>